import OpenBase64ImageInPopup from "../../../services/OpenBase64ImageInPopup";

/** MRC document preview — does not change the shared popup used by other services. */
const MrcOpenBase64ImageInPopup = (props) => (
  <OpenBase64ImageInPopup stableViewer {...props} />
);

export default MrcOpenBase64ImageInPopup;
